"use client";

import { useParams, useSearchParams } from "next/navigation";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { useMutation } from "@tanstack/react-query";
import { adminAuthPasswordUpdate } from "@/entities";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}
export default function UserEditPasswordModal({ isOpen, onClose }: Props) {
  const params = useParams<{ id: string }>();
  const searchParams = useSearchParams();

  const id = params?.id || "";

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      password: "",
      passwordConfirm: "",
    },
  });

  const updateMutation = useMutation({
    mutationFn: adminAuthPasswordUpdate,
    onSuccess: () => {
      toast.success("비밀번호가 변경되었습니다.");
      onClose();
    },
    onError: () => {
      toast.error("다시 시도해주세요");
    },
  });
  const onSubmit = async (data: any) => {
    if (updateMutation.isPending) return;

    await updateMutation.mutateAsync({
      id,
      ...data,
    });

    setValue("password", "");
    setValue("passwordConfirm", "");
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ModalHeader toggle={onClose}>비밀번호 변경</ModalHeader>
        <ModalBody className="p-0">
          <div className="form-horizontal form-bordered">
            <Controller
              name="password"
              control={control}
              rules={{
                required: "비밀번호를 입력해주세요.",
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <div className="form-group row">
                  <label className="col-form-label col-md-3">비밀번호</label>
                  <div className="col-md-9">
                    <input
                      type="password"
                      className="form-control"
                      placeholder="비밀번호 입력"
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value || ""}
                    />
                    {errors.password && (
                      <span className="text-red">
                        {errors.password.message as string}
                      </span>
                    )}
                  </div>
                </div>
              )}
            />

            <Controller
              name="passwordConfirm"
              control={control}
              rules={{
                required: "비밀번호 확인을 입력해주세요.",
                validate: (value) => {
                  return value !== watch("password")
                    ? "비밀번호와 비밀번호확인이 일치하지 않습니다. 다시 입력해주세요."
                    : undefined;
                },
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <div className="form-group row">
                  <label className="col-form-label col-md-3">
                    비밀번호 확인
                  </label>
                  <div className="col-md-9">
                    <input
                      type="password"
                      className="form-control"
                      placeholder="비밀번호 확인 입력"
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value || ""}
                    />
                    {errors.passwordConfirm && (
                      <span className="text-red">
                        {errors.passwordConfirm.message as string}
                      </span>
                    )}
                  </div>
                </div>
              )}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <button type="submit" className="btn btn-sm btn-inverse">
            <i className="fa fa-check"></i>
            <span> 저장</span>
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
}
